var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87406 16.4361V4.57631C9.87406 3.45037 9.39366 3 8.20017 3H5.16766C3.97417 3 3.49377 3.45037 3.49377 4.57631V16.4361C3.49377 17.5621 3.97417 18.0124 5.16766 18.0124H8.20017C9.39366 18.0124 9.87406 17.5621 9.87406 16.4361Z",
    fill: "#45A9EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5062 16.5112V4.57631C18.5062 3.45037 18.0258 3 16.8323 3H13.7998C12.6063 3 12.1259 3.45037 12.1259 4.57631V16.5112C12.1259 17.6371 12.6063 18.0875 13.7998 18.0875H16.8323C18.0258 18.0875 18.5062 17.6371 18.5062 16.5112Z",
    fill: "#45A9EF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;